import {
  $,
  React,
  Axios,
  validator,
  ImageUploader,
  Modal,
  dt,
  Select,
} from "../../../Headers";

export default class CreateWebBook extends React.Component {
  constructor() {
    super();
    this.state = {
      BooksData: [],
      formAction: "ADD",
      book_id: "",
      modelIsOpenForSubmit: false,
      modelIsOpenForInactive: false,
      modelIsOpenForResponse: false,
      modelIsOpenForAddCategory: false,
      response: "",
      errors: {},
      articleType: "",
      editRecordId: "",
      server: "",
      articleTypeforvalid: "",
      selectedCategory: "",
      categoryData: [],
      selectedCategoryForValid: "",
      picture: "",
    };
    this.ondrop = this.ondrop.bind(this);
  }
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let book_name = this.book_name.value;
    let isbn = this.isbn.value;
    let edition = this.edition.value;
    let author = this.author.value;
    let aboutBook = this.aboutBook.value;
    let buyLink = this.buyLink.value;
    let category = this.state.selectedCategoryForValid;

    // Trim the value first so strings with just spaces count as empty
    const isBlank = (value) => validator.isEmpty(value.trim());

    if (isBlank(book_name)) {
      formIsValid = false;
      errors["book_name"] = "Book name is required";
    }

    if (isBlank(isbn)) {
      formIsValid = false;
      errors["isbn"] = "ISBN is required";
    }

    if (isBlank(edition)) {
      formIsValid = false;
      errors["edition"] = "Edition is required";
    } else if (!validator.isInt(edition.toString(), { min: 1 })) {
      formIsValid = false;
      errors["edition"] = "Edition must be a positive number";
    }

    if (isBlank(author)) {
      formIsValid = false;
      errors["author"] = "Author is required";
    }

    if (isBlank(aboutBook)) {
      formIsValid = false;
      errors["aboutBook"] = "About‑book description is required";
    }
    if (isBlank(buyLink)) {
      formIsValid = false;
      errors["buyLink"] = "Buy Link is required";
    }
    let price = this.price ? this.price.value : "";
    if (isBlank(price)) {
      formIsValid = false;
      errors["price"] = "Price is required";
    } else if (!validator.isInt(price.toString(), { min: 0 })) {
      formIsValid = false;
      errors["price"] = "Price must be a positive number";
    }
    let sale_price = this.sale_price ? this.sale_price.value : "";
    if (sale_price !== "" && (!validator.isInt(sale_price.toString()) || parseInt(sale_price, 10) < 0)) {
      formIsValid = false;
      errors["sale_price"] = "Sale Price must be a positive number";
    }
    let shipping_charges = this.shipping_charges ? this.shipping_charges.value : "";
    if (shipping_charges !== "" && (!validator.isInt(shipping_charges.toString()) || parseInt(shipping_charges, 10) < 0)) {
      formIsValid = false;
      errors["shipping_charges"] = "Shipping Charges must be a positive number";
    }
    if (validator.isEmpty(category)) {
      formIsValid = false;
      errors["category"] = "Select Category";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  handleChangeCategory = (selectedValue) => {
    this.setState({ selectedCategory: selectedValue });
    this.setState({ selectedCategoryForValid: selectedValue.value });
  };

  ondrop(pictures) {
    this.setState({
      picture: pictures,
    });
  }

  EditBookData = (BookData) => {
    this.setState({ formAction: "EDIT" });
    this.setState({ book_id: BookData.id });
    //console.log(JournalData);

    document.getElementById("book_name").setAttribute("value", BookData.title);

    document.getElementById("isbn").setAttribute("value", BookData.isbn);
    document.getElementById("edition").setAttribute("value", BookData.edition);
    document.getElementById("author").setAttribute("value", BookData.author);
    document.getElementById("aboutBook").setAttribute("value", BookData.about);
    document
      .getElementById("buyLink")
      .setAttribute("value", BookData.buy_link || "");
    const priceElem = document.getElementById("price");
    if (priceElem) priceElem.setAttribute("value", BookData.price !== undefined && BookData.price !== null ? Math.round(BookData.price) : "");
    const salePriceElem = document.getElementById("sale_price");
    if (salePriceElem) salePriceElem.setAttribute("value", BookData.sale_price !== undefined && BookData.sale_price !== null ? Math.round(BookData.sale_price) : (BookData.salePrice !== undefined && BookData.salePrice !== null ? Math.round(BookData.salePrice) : ""));
    const shippingChargesElem = document.getElementById("shipping_charges");
    if (shippingChargesElem) shippingChargesElem.setAttribute("value", BookData.shipping_charges !== undefined && BookData.shipping_charges !== null ? Math.round(BookData.shipping_charges) : (BookData.shippingCharges !== undefined && BookData.shippingCharges !== null ? Math.round(BookData.shippingCharges) : ""));
    const selectedData = this.state.categoryData.find(
      (category) => category.value == BookData.category_id
    );
    console.log(selectedData);
    if (selectedData) {
      this.setState({
        selectedCategory: {
          value: selectedData.value,
          label: selectedData.label,
        },
      });
      this.setState({ selectedCategoryForValid: BookData.category_id });
    }
  };

  ResetForm = () => {
    this.setState({ formAction: "ADD", selectedsubject: "", picture: "" });
    document.getElementById("book_name").removeAttribute("value");
    const priceElem = document.getElementById("price");
    if (priceElem) priceElem.removeAttribute("value");
    const salePriceElem = document.getElementById("sale_price");
    if (salePriceElem) salePriceElem.removeAttribute("value");
    const shippingChargesElem = document.getElementById("shipping_charges");
    if (shippingChargesElem) shippingChargesElem.removeAttribute("value");
  };

  SubmitJournals = (event) => {
    event.preventDefault();
    event.persist();
    this.setState({ modelIsOpenForSubmit: false });

    const priceVal = parseInt(this.price && this.price.value ? this.price.value : 0, 10);
    const salePriceVal = parseInt(this.sale_price && this.sale_price.value ? this.sale_price.value : 0, 10);
    const shippingChargesVal = parseInt(this.shipping_charges && this.shipping_charges.value ? this.shipping_charges.value : 0, 10);

    if (this.state.formAction == "ADD") {
      const fd = new FormData();

      fd.append("bookName", this.book_name.value.toUpperCase());
      fd.append("isbn", this.isbn.value);
      fd.append("edition", this.edition.value);
      fd.append("author", this.author.value);
      fd.append("aboutBook", this.aboutBook.value);
      fd.append("buyLink", this.buyLink.value);
      fd.append("price", priceVal);
      fd.append("salePrice", salePriceVal);
      fd.append("shippingCharges", shippingChargesVal);
      fd.append("category", this.state.selectedCategory.value);
      fd.append("bookImages", this.state.picture[0]);
      Axios.post(
        "//" + this.state.server + "/controller/AddWebBooksController.php",
        fd
      )
        .then(
          function (res) {
            if (res.data.Success == 1) {
              this.setState({
                response: res.data.value.Msg,
                modelIsOpenForResponse: true,
              });
            } else {
              this.setState({
                response: res.data.value.Msg,
                modelIsOpenForResponse: true,
              });
            }
          }.bind(this)
        )
        .catch(function (error) {
          //console.log(error);
        });
    } else if (this.state.formAction == "EDIT") {
      const fd = new FormData();
      fd.append("bookId", this.state.book_id);
      fd.append("bookName", this.book_name.value.toUpperCase());
      fd.append("isbn", this.isbn.value);
      fd.append("edition", this.edition.value);
      fd.append("author", this.author.value);
      fd.append("aboutBook", this.aboutBook.value);
      fd.append("buyLink", this.buyLink.value);
      fd.append("price", priceVal);
      fd.append("salePrice", salePriceVal);
      fd.append("shippingCharges", shippingChargesVal);
      fd.append("category", this.state.selectedCategory.value);
      fd.append("bookImages", this.state.picture[0]);
      fd.append("category", this.state.selectedCategory.value);
      fd.append("bookImages", this.state.picture[0]);
      Axios.post(
        "//" + this.state.server + "/controller/EditWebBooksController.php",
        fd
      )
        .then(
          function (res) {
            if (res.data.Success == 1) {
              this.setState({
                response: res.data.Msg,
                modelIsOpenForResponse: true,
              });
              //console.log(res);
            } else {
              this.setState({
                response: res.data.Msg,
                modelIsOpenForResponse: true,
              });
              //console.log(res);
            }
          }.bind(this)
        )
        .catch(function (error) {
          //console.log(error);
        });
      this.setState({ formAction: "ADD" });
      this.setState({ articleid: "" });
    }
  };

  InactiveArticle = () => {
    this.setState({ modelIsOpenForInactive: false });
    // alert(ArticleConfigToInactive);
    // event.preventDefault();
    // event.persist();
    Axios.post(
      "//" + this.state.server + "/controller/InactiveWebBookController.php",
      {
        bookId: this.state.book_id,
      }
    )
      .then(
        function (res) {
          if (res.data.success == 1) {
            this.setState({
              response: res.data.Msg,
              modelIsOpenForResponse: true,
            });
            //console.log(res);
          } else {
            this.setState({
              response: res.data.Msg,
              modelIsOpenForResponse: true,
            });
            //console.log(res);
          }
        }.bind(this)
      )
      .catch(function (error) {
        //console.log(error);
      });
  };

  ToOpenModel = (event, button, idForInactive) => {
    event.preventDefault();
    event.persist();
    if (button == "submit") {
      if (this.handleValidation()) {
        this.setState({
          modelIsOpenForSubmit: true,
        });
      }
    } else if (button == "inactive") {
      this.setState({
        modelIsOpenForInactive: true,
        book_id: idForInactive,
      });
    }
  };

  componentDidMount() {
    const server = window.$name;
    this.setState({ server: server });

    Axios.all([
      Axios.post(
        "//" + window.$name + "/controller/GetWebBooksForTableController.php",
        {}
      ),
      Axios.post(
        "//" + window.$name + "/controller/GetWebCategoryController.php",
        {}
      ), Axios.post(
        "//" + window.$name + "/controller/GetWebCategoryController.php",
        {}
      ),
    ])
      .then((res) => {
        this.setState({ BooksData: res[0].data });
        this.setState({ categoryData: res[1].data });

        //console.log(this.state.BooksData);
        $("#table").DataTable({
          responsive: true,
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
            { responsivePriority: 1, targets: -1 },
            { responsivePriority: 2, targets: 1 },
            { responsivePriority: 3, targets: 0 },
          ],
        });
      })
      .catch((error) => {
        //console.log(error);
      });
  }

  AddCategory = () => {
    this.setState({ modelIsOpenForAddCategory: false });
    Axios.post(
      "//" + this.state.server + "/controller/WebBookCategoryController.php",
      {
        category: this.addCategory.value,
      }
    )
      .then(
        function (res) {
          if (res.data.success == 1) {
            this.setState({
              response: res.data.Msg,
              modelIsOpenForResponse: true,
            });
          } else {
            this.setState({
              response: res.data.Msg,
              modelIsOpenForResponse: true,
            });
          }
        }.bind(this)
      )
      .catch(function (error) {
        //console.log(error);
      });
  };
  render() {
    return (
      <>
        <section class="content ">
          <div
            id="Journal_form"
            class="container d-flex justify-content-center"
          >
            <div className="col-md-10 col-lg-8" id="ss-sad-login-007">
              <div id="ss-sad-login-008" class="card-header text-left">
                <div class="ss-sad-login-009" style={{ textAlign: "center" }}>
                  {this.state.formAction === "EDIT" ? "Edit Book" : "Create Book"}
                </div>
              </div>
              <div className="container p-3">
                <form
                  onSubmit={(event) => this.ToOpenModel(event, "submit", "")}
                  onReset={this.ResetForm}
                >
                  <div className="form">
                    <div className="row">
                      {/* Book Name */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Book Name
                          </label>
                          <input
                            id="book_name"
                            type="text"
                            name="book_name"
                            ref={(val) => (this.book_name = val)}
                            className="form-control"
                            placeholder="Book Name"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["book_name"]}
                          </span>
                        </div>
                      </div>

                      {/* ISBN */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            ISBN
                          </label>
                          <input
                            id="isbn"
                            type="number"
                            name="isbn"
                            ref={(val) => (this.isbn = val)}
                            className="form-control"
                            placeholder="ISBN"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["isbn"]}
                          </span>
                        </div>
                      </div>

                      {/* Edition */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Edition
                          </label>
                          <input
                            id="edition"
                            type="number"
                            min="1"
                            step="1"
                            name="edition"
                            ref={(val) => (this.edition = val)}
                            className="form-control"
                            placeholder="Edition"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["edition"]}
                          </span>
                        </div>
                      </div>

                      {/* Category */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Category
                          </label>
                          <div className="d-flex align-items-center">
                            <div style={{ flexGrow: 1 }}>
                              <Select
                                onChange={this.handleChangeCategory}
                                options={this.state.categoryData}
                                value={this.state.selectedCategory}
                                placeholder="Select Category"
                              />
                            </div>
                            <div
                              className="add-btn ml-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.setState({
                                  modelIsOpenForAddCategory: true,
                                });
                              }}
                            >
                              <i className="fas fa-plus"></i>
                            </div>
                          </div>
                          <span style={{ color: "red" }}>
                            {this.state.errors["category"]}
                          </span>
                        </div>
                      </div>

                      {/* About Author */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            About the Author
                          </label>
                          <input
                            id="author"
                            type="text"
                            name="author"
                            ref={(val) => (this.author = val)}
                            className="form-control"
                            placeholder="About the author"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["author"]}
                          </span>
                        </div>
                      </div>

                      {/* About Book */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            About the Book
                          </label>
                          <input
                            id="aboutBook"
                            type="text"
                            name="aboutBook"
                            ref={(val) => (this.aboutBook = val)}
                            className="form-control"
                            placeholder="About the book"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["aboutBook"]}
                          </span>
                        </div>
                      </div>

                      {/* Price */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Price (₹)
                          </label>
                          <input
                            id="price"
                            type="number"
                            min="0"
                            step="1"
                            name="price"
                            ref={(val) => (this.price = val)}
                            className="form-control"
                            placeholder="Price (₹)"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["price"]}
                          </span>
                        </div>
                      </div>

                      {/* Sale Price */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Sale Price (₹)
                          </label>
                          <input
                            id="sale_price"
                            type="number"
                            min="0"
                            step="1"
                            name="sale_price"
                            ref={(val) => (this.sale_price = val)}
                            className="form-control"
                            placeholder="Sale Price (₹)"
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["sale_price"]}
                          </span>
                        </div>
                      </div>

                      {/* Shipping Charges */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Shipping Charges (₹)
                          </label>
                          <input
                            id="shipping_charges"
                            type="number"
                            min="0"
                            step="1"
                            name="shipping_charges"
                            ref={(val) => (this.shipping_charges = val)}
                            className="form-control"
                            placeholder="Shipping Charges (₹)"
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["shipping_charges"]}
                          </span>
                        </div>
                      </div>

                      {/* Buy Link */}
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group text-left">
                          <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                            Buy Link
                          </label>
                          <input
                            id="buyLink"
                            type="text"
                            name="buyLink"
                            ref={(val) => (this.buyLink = val)}
                            className="form-control"
                            placeholder="Buy link"
                            required
                          />
                          <span style={{ color: "red" }}>
                            {this.state.errors["buyLink"]}
                          </span>
                        </div>
                      </div>

                      {/* Upload Image (Full Width) */}
                      <div className="col-md-12 col-sm-12 text-left">
                        <label className="font-weight-bold" style={{ textAlign: "left", display: "block", marginBottom: "4px" }}>
                          Upload Book Image
                        </label>
                        <ImageUploader
                          withIcon={false}
                          withPreview={true}
                          required
                          buttonText="Upload Images"
                          onChange={this.ondrop}
                          imgExtension={[".jpg", ".png"]}
                          maxFileSize={5000000}
                          label="Max file size 5mb, accepted: jpg|png"
                          fileSizeError=" file size is too big"
                        ></ImageUploader>
                      </div>
                    </div>

                    <div className="row d-flex justify-content-center mt-3">
                      <button
                        type="submit"
                        id="ss-sad-login-014"
                        className="btn btn-block col-md-3 col-sm-5 m-1"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        className="btn btn-block col-md-3 col-sm-5 m-1"
                        id="reset"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="container-fluid mt-3">
            <table
              id="table"
              className="display hover dt[-head|-body]-justify"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Book Name</th>
                  <th>Isbn</th>
                  <th>Edition</th>
                  <th>Price</th>
                  <th>Sale Price</th>
                  <th>Shipping Charges</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.BooksData.map((data) => (
                  <tr>
                    <td></td>
                    <td>{data.title}</td>
                    <td>{data.isbn}</td>
                    <td>{data.edition}</td>
                    <td>{data.price !== undefined && data.price !== null ? `₹${parseInt(data.price, 10)}` : "-"}</td>
                    <td>{data.sale_price !== undefined && data.sale_price !== null ? `₹${parseInt(data.sale_price, 10)}` : (data.salePrice !== undefined && data.salePrice !== null ? `₹${parseInt(data.salePrice, 10)}` : "-")}</td>
                    <td>{data.shipping_charges !== undefined && data.shipping_charges !== null ? `₹${parseInt(data.shipping_charges, 10)}` : (data.shippingCharges !== undefined && data.shippingCharges !== null ? `₹${parseInt(data.shippingCharges, 10)}` : "-")}</td>
                    <td>
                      <div className="btn-group">
                        <a href="#Journal_form" className="m-2">
                          <button
                            type="button"
                            class="btn-lg  responsive_btn"
                            id="edit"
                            title="Edit"
                            value="Edit"
                            onClick={() => this.EditBookData(data)}
                          >
                            <i class="far fa-edit"></i>
                          </button>
                        </a>
                        <button
                          type="button"
                          class="btn-lg   responsive_btn m-2"
                          title="Inactive"
                          id="inactive"
                          value="Inactive"
                          onClick={(event) =>
                            this.ToOpenModel(event, "inactive", data.id)
                          }
                        >
                          <i class="far fa-eye-slash"></i>
                        </button>
                        {/* <button type="button" class="btn-lg  responsive_btn m-2" title="Delete" id="delete" value="Delete" onClick={() => this.DeleteArticle(data.book_id)} ><i class="far fa-trash-alt"></i></button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        {/* </div> */}
        {/* <Modal isOpen={this.state.modelIsOpenForSubmit} className="popup-modal-content" overlayClassName="popup-modal" onRequestClose={() => this.setState({ modelIsOpenForSubmit: false })}>
                    <span class="closed" onClick={() => this.setState({ modelIsOpenForSubmit: false })}>&times;</span>
                    <h2>Do you want to submit this record ?</h2>
                    <button className="btn btn-primary col-sm-2 mr-2 mb-2 popup-btn" onClick={this.SubmitJournals}><i class="fas fa-check" style={{ fontSize: "25px" }}></i></button>
                    <button className="btn btn-danger col-sm-2 mr-2 mb-2 popup-btn" onClick={() => this.setState({ modelIsOpenForSubmit: false })}><i class="fas fa-times" style={{ fontSize: "29px" }}></i></button>
                </Modal> */}
        <Modal
          isOpen={this.state.modelIsOpenForSubmit}
          className="popup-modal-content-subscribe"
          overlayClassName="popup-modal"
          onRequestClose={() => this.setState({ modelIsOpenForSubmit: false })}
        >
          <span
            class="closed"
            type="button"
            style={{
              fontSize: "32px",
              position: "absolute",
              zIndex: "1",
              right: "3%",
              height: "6.7vh",
              lineHeight: "6.7vh",
            }}
            onClick={() => this.setState({ modelIsOpenForSubmit: false })}
          >
            &times;
          </span>
          <div
            className="card-header"
            id="ss-uad-article-10"
            style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
          >
            {/* <i class="fas fa-comment-alt mr-2" id="ss-uad-article-11"></i> */}
            <span id="ss-uad-article-12">Alert</span>
          </div>
          <div class="card-body">
            <p id="assign-popup-box-msg">Do you want to submit this record ?</p>
            {/* <h1>Approve</h1> */}
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                id="ss-uad-article-09"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-primary mr-2 col-5"
                type="submit"
                onClick={this.SubmitJournals}
              >
                <i class="fas fa-check" style={{ fontSize: "25px" }}></i>
              </button>
              <button
                id="ss-uad-article-08"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-danger col-5"
                onClick={() => this.setState({ modelIsOpenForSubmit: false })}
              >
                <i class="fas fa-times" style={{ fontSize: "29px" }}></i>
              </button>
            </div>
          </div>
        </Modal>
        {/* <Modal isOpen={this.state.modelIsOpenForInactive} className="popup-modal-content" overlayClassName="popup-modal" onRequestClose={() => this.setState({ modelIsOpenForInactive: false })}>
                    <span class="closed" onClick={() => this.setState({ modelIsOpenForInactive: false })}>&times;</span>
                    <h2>Do you want to inactive this record ?</h2>
                    <button className="btn btn-primary col-sm-2 mr-2 mb-2 popup-btn" onClick={this.InactiveArticle}><i class="fas fa-check" style={{ fontSize: "25px" }}></i></button>
                    <button className="btn btn-danger col-sm-2 mr-2 mb-2 popup-btn" onClick={() => this.setState({ modelIsOpenForInactive: false })}><i class="fas fa-times" style={{ fontSize: "29px" }}></i></button>
                </Modal> */}
        <Modal
          isOpen={this.state.modelIsOpenForInactive}
          className="popup-modal-content-subscribe"
          overlayClassName="popup-modal"
          onRequestClose={() =>
            this.setState({ modelIsOpenForInactive: false })
          }
        >
          <span
            class="closed"
            type="button"
            style={{
              fontSize: "32px",
              position: "absolute",
              zIndex: "1",
              right: "3%",
              height: "6.7vh",
              lineHeight: "6.7vh",
            }}
            onClick={() => this.setState({ modelIsOpenForInactive: false })}
          >
            &times;
          </span>
          <div
            className="card-header"
            id="ss-uad-article-10"
            style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
          >
            {/* <i class="fas fa-comment-alt mr-2" id="ss-uad-article-11"></i> */}
            <span id="ss-uad-article-12">Alert</span>
          </div>
          <div class="card-body">
            <p id="assign-popup-box-msg">
              Do you want to inactive this record ?
            </p>
            {/* <h1>Approve</h1> */}
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                id="ss-uad-article-09"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-primary mr-2 col-5"
                type="submit"
                onClick={this.InactiveArticle}
              >
                <i class="fas fa-check" style={{ fontSize: "25px" }}></i>
              </button>
              <button
                id="ss-uad-article-08"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-danger col-5"
                onClick={() => this.setState({ modelIsOpenForInactive: false })}
              >
                <i class="fas fa-times" style={{ fontSize: "29px" }}></i>
              </button>
            </div>
          </div>
        </Modal>
        {/* <Modal isOpen={this.state.modelIsOpenForResponse} className="popup-modal-content" overlayClassName="popup-modal" onRequestClose={() => window.location.reload()}>
                    <span class="closed" onClick={() => window.location.reload()}>&times;</span>
                    <h4>{this.state.response}</h4>
                    <button className="btn btn-primary col-sm-2 mr-2 mb-2 popup-ok-btn" onClick={() => window.location.reload()}><i class="fas fa-thumbs-up" style={{ fontSize: "29px" }}></i></button>
                </Modal> */}
        <Modal
          isOpen={this.state.modelIsOpenForResponse}
          className="popup-modal-content-success"
          overlayClassName="popup-modal"
          onRequestClose={() => window.location.reload()}
        >
          <div className="row" style={{ height: "100%", margin: "0px" }}>
            <div className="col-9" style={{ paddingTop: "6px" }}>
              <p id="popup-title">Remark</p>
              {/* <p id="popup-content">{this.state.response}</p> */}
              <p id="popup-content">{this.state.response}</p>
            </div>
            <div
              className="col-3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                id="ss-uad-article-09"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-primary"
                onClick={() => window.location.reload()}
              >
                <i class="fas fa-check" style={{ fontSize: "29px" }}></i>
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modelIsOpenForAddCategory}
          className="popup-modal-content-subscribe"
          overlayClassName="popup-modal"
          onRequestClose={() => {
            this.setState({ modelIsOpenForAddCategory: false });
          }}
        >
          <div className="row add-category-modal">
            <div className="col-md-12 col-sm-12">
              <div className="form-group">
                <input
                  id="addCategory"
                  type="text"
                  name="addCategory"
                  ref={(val) => (this.addCategory = val)}
                  className="form-control"
                  placeholder="Category"
                  required
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <button
                id="ss-uad-article-09"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-primary mr-2 col-5"
                type="submit"
                onClick={this.AddCategory}
              >
                <i class="fas fa-check" style={{ fontSize: "25px" }}></i>
              </button>
              <button
                id="ss-uad-article-08"
                style={{
                  height: "50px",
                  lineHeight: "initial",
                  padding: "initial",
                  width: "110px",
                }}
                className="btn btn-danger col-5"
                onClick={() =>
                  this.setState({ modelIsOpenForAddCategory: false })
                }
              >
                <i class="fas fa-times" style={{ fontSize: "29px" }}></i>
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
